(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["retailers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const containerEl = document.querySelector('.so-section-retailers .retailers');
    if (!containerEl) return;

    // Get the section's wrapper element
    const sectionElement = containerEl.closest('.so-section-retailers');
    if (!sectionElement) return;

    // Ensure the MixItUp library is loaded
    if (typeof mixitup === 'undefined') {
      console.error('MixItUp library is not loaded.');
      return;
    }

    // Read the initial filter value from the HTML data attribute
    const initialFilter = sectionElement.dataset.initialFilter || 'all';

    const mixer = mixitup(containerEl, {
      load: {
        filter: initialFilter
      }
    });

    const filterDropdown = document.getElementById('retailer-filter-dropdown');
    filterDropdown.addEventListener('change', function() {
      const filterValue = this.value;
      mixer.filter(filterValue);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
